<template>
    <div class="py-4 text-center">
        <p>
            <slot />
        </p>
        <img :src="image" />
    </div>
</template>

<script>
export default {
    name: 'ImageContainer',
    props: {
        image: {
            type: String,
            required: true,
        },
    },
}
</script>
